import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import PageHeader from "./components/header";
import Receipt from "./components/receipt";

const VoucherReceipt = () => {
  const navigate = useNavigate();
  const data = useSelector((state) => state?.voucherReducer?.data);
  const onClose = () => {
    navigate("/");
  };

  return (
    <div className="items-center pma-layout !bg-gray--12 max-w-2xl  w-full m-auto flex flex-col h-[100vh]">
      <PageHeader title={""} onClose={onClose} />
      <div className="fixed top-0 px-5 w-full max-w-2xl h-[426px] bg-gradient-to-b from-primary-0  to-primary-2" />
      <div className="w-full max-w-2xl z-4 relative">
        <Receipt {...data} />
      </div>
    </div>
  );
};

export default VoucherReceipt;
